
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';
import { Modal } from '../../overlay';
import SunStudyContainer from './SunStudyContainer';

type SunStudyModalProps={
};
export const getImageDimensionsOf = (url: string): Promise<{ height: number, width: number}> => {

    return new Promise(resolve => {
        // create the video element
        const image = document.createElement('img');
        // place a listener on it
        image.addEventListener('load', function () {
            // retrieve dimensions
            const height = this.height;
            const width = this.width;
            // send back result
            resolve({ height, width });
        }, false);

        // start download meta-datas
        image.style.display = 'none';
        image.src = url;
    });
};

const SunStudyModal: React.FC<SunStudyModalProps> = (): ReactElement => {
    const { presentationState } = useContext(AppContext);

    useEffect(() => {
        presentationState?.setWidth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [ratio, setRatio] = useState(1.2);
    useEffect(() => {
        const url = presentationState?.showSunStudyModal?.files?.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)[0]?.url?.original;

        url && getImageDimensionsOf(url).then(result => {
            setRatio((result.width / result.height));
        });
    }, [presentationState?.showSunStudyModal?.files]);

    const getSunStudyWidth = (width: number): number => {

        if (width < 400) {
            width = width * 0.75;
        }
        else if (width < 450) {
            width = width * 0.8;
        }
        else if (width < 700) {
            width = width * 0.85;
        }
        else if (width) {
            width = width * 0.9;
        }

        return width;
    };

    return useObserver(() => (
        <Modal
            showModal={!!presentationState?.showSunStudyModal}
            onBackdropClick={(): void => {
                presentationState?.setShowSunStudyModal(undefined);
            }}
            modalPaperStyle={{
                maxHeight: 'unset',
                margin: 0,
                backgroundColor: '#f1f1f1',
                maxWidth: 'unset',
                height:  isMobile() ? 'auto' : 'calc(100% - 2rem)',
                width: isMobile() ? '100%' : presentationState?.modalWidth && ((`calc(${(getSunStudyWidth(presentationState.modalWidth) * ratio)}px)`) || '80vh'),
                borderRadius: '2rem',
                overflow:'hidden' }}>
            <SunStudyContainer/>
        </Modal>));
};


export default SunStudyModal;